<template>
  <v-dialog v-model="dialog" max-width="800px" class="mx-auto" persistent>
    <v-card class="pa-4">
      <v-card-title>Solicitudes de Certificados</v-card-title>


      <v-card-text v-if="inscripcion">
          <v-list two-line>
            <v-list-item v-if="inscripcion.estudiante">
              <v-list-item-icon>
                <v-icon color="indigo">
                  mdi-account-multiple
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content >
                <v-list-item-title>{{ inscripcion.estudiante.nombres }} {{ inscripcion.estudiante.pri_apellido }} {{
                  inscripcion.estudiante.seg_apellido }}</v-list-item-title>
                <v-list-item-subtitle>Documento {{ inscripcion.estudiante.num_doc }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="indigo">
                  mdi-package
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="text-wrap">{{ inscripcion.programa.nombre_compuesto }} </v-list-item-title>
                <!-- <v-list-item-subtitle>Documento {{ inscripcion.estudiante.num_doc }}</v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>

          </v-list>


          <v-data-table :headers="headers" :items="solicitudes" :loading="loading" class="elevation-1">
            <template v-slot:top>
              <v-toolbar flat>
                <!-- <v-toolbar-title>Gestión de Programas</v-toolbar-title> -->
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 4 ||$store.state.CARGO.id == 3 || $store.state.CARGO.id == 26"
                 color="primary" dark class="mb-2" @click="openDialog()">
                  Nueva Solicitud
                </v-btn>
              </v-toolbar>
            </template>

             <!-- Estado -->
             <template v-slot:item.Estado="{ item }">
              <v-chip :color="estadoColores[item.Estado]" dark small>
                {{ mostrarEstado(item.Estado) }}
              </v-chip>
            </template>

            <!-- Columna de Acciones (Editar/Eliminar) -->
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="verSolicitud(item)">
                mdi-pencil
              </v-icon>
              <v-icon  v-if="item.Estado=='emitido'" color="green" small class="mr-2" @click="verCertificado(item)">
                mdi-certificate
              </v-icon>
              <!-- <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon> -->
            </template>

            <!-- Columna de Estado Activo -->
            <template v-slot:item.EsGratuito="{ item }">
              <v-chip :color="item.EsGratuito ? 'green' : 'red'" dark small>
                {{ item.EsGratuito ? 'Gratuito' : 'No Gratuito' }}
              </v-chip>
            </template>
          </v-data-table>

      </v-card-text>
      <v-card-actions>
        <v-spacer />

        <v-btn color="danger" :loading="cargando" @click="cerrarSolicitud">
          Cerrar
        </v-btn>

      </v-card-actions>
      <v-dialog v-model="dialog1" max-width="600px" persistent>
        <v-card>
          <v-card-title>Nueva Solicitud</v-card-title>
          <v-divider></v-divider>


          <v-card-text>
            
              <v-list dense v-if="inscripcion">

                <!-- Estudiante -->
                <v-list-item v-if="inscripcion.estudiante">
                  <v-list-item-icon>
                    <v-icon color="indigo">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ inscripcion.estudiante.nombres }}
                      {{ inscripcion.estudiante.pri_apellido }}
                      {{ inscripcion.estudiante.seg_apellido }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Documento: {{ inscripcion.estudiante.num_doc }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <!-- Programa -->
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="deep-purple">mdi-school</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap">
                      {{ inscripcion.programa.nombre_compuesto }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            <v-divider inset></v-divider>

            <v-select return-object v-model="programauniversidad" :items="programauniversidades"
              label="Universidad Certificacion" item-text="Universidad.Nombre" item-value="id" required
              persistent-hint></v-select>
            <v-row v-if="programauniversidad">


              <v-col cols="12" sm="6">
                <v-text-field label="Monto" :value="programauniversidad.precio" readonly />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Moneda" :value="programauniversidad.moneda" readonly />
              </v-col>
            </v-row>

            <v-select v-model="opcionSeleccionada" :items="opciones" label="Tipo de Solicitud" item-text="label"
              item-value="value" required></v-select>

            <v-textarea v-if="requiereMotivo" v-model="motivo" label="Motivo" auto-grow></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" :loading="cargando" @click="solicitarCertificado">
              Solicitar
            </v-btn>
            <v-btn color="danger" :loading="cargando" @click="cerrarDialog">
              Cerrar
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCertificado" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6 font-weight-bold">Certificado</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCertificado = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-progress-linear
        :active="loadingCertificado"
        :indeterminate="loadingCertificado"
        absolute
        center
       
      ></v-progress-linear>
          <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="600px"></iframe>         
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>



      <v-dialog v-model="dialog2" max-width="600px" persistent>
        <v-card>
          <v-card-title>Solicitud</v-card-title>

          <v-card-text>
         
            <v-row v-if="solicitudSeleccionado">
              <v-list dense v-if="inscripcion">

                <!-- Estudiante -->
                <v-list-item v-if="inscripcion.estudiante">
                  <v-list-item-icon>
                    <v-icon color="indigo">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ inscripcion.estudiante.nombres }}
                      {{ inscripcion.estudiante.pri_apellido }}
                      {{ inscripcion.estudiante.seg_apellido }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Documento: {{ inscripcion.estudiante.num_doc }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <!-- Programa -->
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="deep-purple">mdi-school</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap">
                      {{ inscripcion.programa.nombre_compuesto }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>


                <!-- Universidad -->
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="blue">mdi-domain</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ solicitudSeleccionado.ProgramaUniversidad.Universidad.Nombre }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- Moneda y Precio -->
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="green">mdi-currency-usd</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ solicitudSeleccionado.ProgramaUniversidad.precio }} {{
                        solicitudSeleccionado.ProgramaUniversidad.moneda }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>


              </v-list>
            </v-row>
            <v-divider inset></v-divider>

            <v-row >
            <v-col cols="12">
              <v-file-input
                label="Subir Fotografia Para Certificado"
                show-size
                counter
                prepend-icon="mdi-camera"
                accept="image/png, image/jpeg, image/bmp, image/gif"
                v-model="selectedImageFile"
                @change="onFileSelected"
              ></v-file-input>
            </v-col>
            <v-col>
              <v-alert
  dense
  type="info"
  outlined
  text
  class="mt-2"
>
  La fotografía debe tener fondo blanco, con traje formal,  formato JPG o PNG, tamaño máximo de 2MB, y mostrar claramente el rostro de frente.
</v-alert>

            </v-col>
            <v-col cols="12" v-if="imagePreviewUrl">
              <v-img
                :src="imagePreviewUrl"
                contain
                max-height="200"
                class="grey lighten-2"
              ></v-img>
              <v-btn
                small
                text
                color="error"
                class="mt-2"
                @click="clearImage"
              >
                <v-icon left>mdi-close-circle</v-icon>
                Quitar imagen
              </v-btn>
              <v-btn
                small
                
                color="primary"
                class="mt-2"
                @click="submitRequest"
              >
                <v-icon left>mdi-check-circle</v-icon>
                Subir Fotografia
              </v-btn>
            </v-col>
        
          </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <!-- <v-btn color="primary" :loading="cargando" @click="dialog2 = false">
              Solicitar
            </v-btn> -->
            <v-btn color="danger" :loading="cargando" @click="cerrarDialog2">
              Cerrar
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-card>
  </v-dialog>
</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
//import xaxios from 'xaxios';

const API_URL = `${process.env.VUE_APP_API_CERTIFICACIONES}/api/v1`;


export default {
  name: 'SolicitudCertificado',
  data() {
    return {
      selectedImageFile: null, // Para guardar el objeto File
      imagePreviewUrl: null,   // Para guardar la URL del preview
      imageB64: null, // <-- Nueva variable para almacenar la imagen en Base64
      inscripcionID:null,
      imageRules: [
        value => !value || value.size < 2000000 || 'El tamaño de la imagen debe ser menor a 2 MB!',
        // Puedes añadir más reglas, por ejemplo, para tipos de archivo si no usas 'accept'
      ],
      loading: true,
      programas: [],
      solicitudes: [],
      programauniversidades: [],
      dialog1: false,
      dialog: false,
      dialogCertificado: false,
      dialog2: false,
      pdfUrl: null, // URL del PDF del certificado
      headers: [
        { text: 'ID', value: 'ID', sortable: true },
        { text: 'Universidad', value: 'ProgramaUniversidad.Universidad.Nombre', sortable: true },
        { text: 'Precio', value: 'ProgramaUniversidad.precio' },
        { text: 'Moneda', value: 'ProgramaUniversidad.moneda' },
        { text: 'Es Gratuito', value: 'EsGratuito' },
        { text: 'Estado', value: 'Estado' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      programauniversidad: null,
      solicitudSeleccionado: null,


      opcionSeleccionada: null,
      motivo: '',
      inscripcion: null,
      padre: {},
      usuario: null,
      estadoColores: {
        pendiente_pago: 'orange',
        pendiente_aprobacion: 'yellow darken-2',
        listo_para_emitir: 'blue',
        emitido: 'green',
        rechazado: 'red'
      },
      loadingCertificado: false,


      cargando: false,
      opciones: [
        { label: 'Solicitud del Cliente, con costo asociado', value: 'paid' },
        { label: 'Solicitud interna con beneficio del 100%', value: 'granted' }
      ]
    };
  },
  computed: {
    requiereMotivo() {
      return this.opcionSeleccionada === 'granted';
    }
  },
 
  watch: {
    // Escucha cambios en dialog2 para limpiar la imagen cuando el diálogo se cierra
    dialog2(val) {
      if (!val) {
        this.clearImage();
      }
    },
    dialogCertificado(val) {
      if (!val) {
        this.pdfUrl = null; // Limpia la URL del PDF cuando se cierra el diálogo
      }
    }

  },

  methods: {
    mostrarEstado(estado) {
      const mapa = {
        pendiente_pago: 'Pendiente de Pago',
        pendiente_aprobacion: 'Pendiente de Aprobación',
        listo_para_emitir: 'Listo Para Emitir',
        emitido: 'Emitido',
        rechazado: 'Rechazado'
      };
      return mapa[estado] || estado;
    },
    cerrarDialog2(){
      this.dialog2 = false;
      this.clearImage();

    },
    onFileSelected(file) {
      this.selectedImageFile = file;
      this.imagePreviewUrl = null;
      this.imageB64 = null; // Limpia el Base64 anterior

      if (file) {
        // Generar URL para el preview
        this.imagePreviewUrl = URL.createObjectURL(file);

        // Crear FileReader para convertir a Base64
        const reader = new FileReader();
        reader.readAsDataURL(file); // Lee el archivo como una URL de datos (Base64)
        reader.onload = () => {
          //this.imageB64 = reader.result; // Asigna el resultado (cadena Base64) a imageB64
          // El resultado incluye el prefijo 'data:image/png;base64,...'
          // Tu backend podría necesitarlo o no. Si no lo necesita, puedes hacer:
          this.imageB64 = reader.result.split(',')[1];
        };
        reader.onerror = (error) => {
          window.console.error("Error al leer el archivo:", error);
          this.showSnackbar('Error al leer el archivo de imagen.', 'error');
          this.clearImage(); // Limpia la selección si hay error
        };
      } else {
        this.clearImage();
      }
    },
    // clearImage() {
    //   this.selectedImageFile = null;
    //   if (this.imagePreviewUrl) {
    //     URL.revokeObjectURL(this.imagePreviewUrl); // Libera la memoria de la URL de objeto
    //     this.imagePreviewUrl = null;
    //   }
    // },
    clearImage() {
      this.selectedImageFile = null;
      this.imageB64 = null; // Limpia la cadena Base64
      if (this.imagePreviewUrl) {
        URL.revokeObjectURL(this.imagePreviewUrl);
        this.imagePreviewUrl = null;
      }
    },
    async submitRequest() {
      if (!this.imageB64) {
        this.$root.$notify.show(`Por favor, selecciona una imagen.`, { color: 'warning' });

//        this.showSnackbar('Por favor, selecciona una imagen.', 'warning');
        return;
      }

      // Prepara los datos a enviar
      const payload = {
        //enrollment_id: this.inscripcion.id, // Ejemplo: otros datos de tu solicitud
      //  option_id: this.solicitudSeleccionado.option_id, // Ejemplo
        foto_base64: this.imageB64, // <-- La imagen Base64
        // ... otros campos que tu backend necesite
      };
      window.console.log('Datos a enviar (incluye Base64):', payload);


      try {
        // Reemplaza con tu lógica real para enviar a tu API
        // this.cargando = true;
        // const response = await xaxios.post(`${API_URL}/tu-endpoint-de-subida`, payload);

        // Ejemplo de simulación de envío:
        this.$root.$notify.show(`Enviando solicitud con imagen...`, { color: 'info' });

//        this.showSnackbar('Enviando solicitud con imagen...', 'info');
        window.console.log('Datos a enviar (incluye Base64):', payload);
        const response = await xaxios.post(`${API_URL}/certificados/request/${this.solicitudSeleccionado.ID}/upload-foto`, payload)

        // Puedes capturar y verificar el status
        if (response.status === 200 || response.status === 201) {
          this.$root.$notify.show(`Solicitud enviada correctamente`, { color: 'success' });
          //this.busqueda(); // Recargar solicitudes después de enviar
          //this.busqueda(); // Recargar solicitudes después de enviar
        } else {
          this.$root.$notify.show(`Solicitud enviada, pero con advertencia (status ${response.status})`, { color: 'warning' });
        }
       // await new Promise(resolve => setTimeout(resolve, 2000)); // Simula una llamada a API

        // Si la petición fue exitosa:
        this.getSolicitudes(this.inscripcion.id);
        this.$root.$notify.show(`Solicitud enviada con éxito.`, { color: 'success' });
        //this.showSnackbar('Solicitud enviada con éxito.', 'success');
        //this.$emit('update:dialog2', false); // Emitir para cerrar el diálogo si es una prop
        // O simplemente: this.dialog2 = false; si es una variable interna
       // this.clearImage(); // Limpia la imagen después del envío
      } catch (error) {
        this.$root.$notify.show(`Error al enviar la solicitud.`, { color: 'error' });
        //this.showSnackbar('Error al enviar la solicitud.', 'error');
        //console.error(error);
      } finally {
        // this.cargando = false;
      }
    },
    async openDialog() {
      this.dialog1 = true
      this.opcionSeleccionada = null;
      this.motivo = '';
      try {
        if (this.inscripcion) {
          const response = await xaxios.get(`${API_URL}/programas/${this.inscripcion.idprograma}/universidad/certificado`);
          this.programauniversidades = response.data || [];
          window.console.log(this.programauniversidades)

        }

      } catch (error) {
        window.console.error("Error al obtener los programas:", error);
        alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }
    },
    cerrarDialog() {
      this.dialog1 = false
    },
    cerrarSolicitud() {
      this.dialog = false;
      this.$emit('cerrar');
    },

    async showThisView(persona_id, inscripcion_id, padre) {
      this.usuario = this.$store.state.DATA_USER;
      this.inscripcionID = inscripcion_id;

      this.padre = padre;
      
      this.loading = true;

      try {
        this.getSolicitudes(inscripcion_id);
        // const response = await xaxios.get(`${API_URL}/certificados/requests/inscripcion/${inscripcion_id}`);
        // this.solicitudes = response.data || [];
        window.console.log(this.solicitudes)
      } catch (error) {
        window.console.error("Error al obtener los programas:", error);
        alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }

      this.inscripcion = await this.get_data_inscripcion(inscripcion_id);
      if (!this.inscripcion.plan_pagos) this.inscripcion.plan_pagos = [];
      //window.console.log('......', this.inscripcion, inscripcion_id);
      this.inscripcion.plan_pagos.forEach((plan) => {
        if (plan.monto != plan.saldo) {
          this.existRecibo = true;
          return;
        }
      });
      this.dialog = true;
      // window.console.log('this.inscripcion', JSON.stringify(this.inscripcion));
      // window.console.log('plan_pagos', JSON.stringify(this.plan_pagos));
    },
    async verSolicitud(item) {
      //window.console.log(item)
      const fotoUUID = item.FotoUUID;

      if(fotoUUID==null || fotoUUID==''){
        this.$root.$notify.show(`No hay fotografia para esta solicitud`, { color: 'warning' });
        this.solicitudSeleccionado = item
        this.dialog2 = true
        return;
      }
      this.loading = true;
      this.imagePreviewUrl = null;
      this.imageB64 = null; // Limpia el Base64 anterior
      try {
        const response = await xaxios.get(`${API_URL}/certificados/requests/foto/${fotoUUID}`);    
       this.imageB64=response.data.file64
       this.imagePreviewUrl=`data:${response.data.mimetype};base64,${this.imageB64}`
        window.console.log(response.data)
      } catch (error) {
        window.console.error("Error al obtener las solicitudes:", error);
        this.$root.$notify.show('Error al obtener la fotografía de la solicitud', { color: 'error' });

       
      } finally {
        this.loading = false;
        this.solicitudSeleccionado = item
        this.dialog2 = true
      }


     
    },

    async getSolicitudes(inscripcion_id) {
      this.loading = true;
      try {
        const response = await xaxios.get(`${API_URL}/certificados/requests/inscripcion/${inscripcion_id}`);
        this.solicitudes = response.data || [];
        window.console.log(this.solicitudes)
      } catch (error) {
        window.console.error("Error al obtener las solicitudes:", error);
       // alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }
    },
    get_data_inscripcion(id) {
      if (this.padre) this.padre.loadinddeta = true;
      const sql = gql`query{ getInscripcion(id:${id}){
            id,idprograma,idestudiante,estado_ins,observaciones,idasesor,fecha_registro,registrado_por,tipopago,puede_cambiar
            asesor {id nombres pri_apellido seg_apellido}
            estudiante {id num_doc nombres pri_apellido seg_apellido domicilio telefono1 telefono2 email fecha_nac contacto estado}
            programa {nombre_compuesto,universidad{id,nombre}}
            plan_programa {id nombre aprobado, cobros_programa{ id monto cuotas estado concepto_pago{id,nombre} }}
            plan_pagos { id monto saldo nro_cuota descuento fecha_pago bloqueado saldo_regularizado concepto_pago{id,nombre}}
            more_programas{ id, nombre_compuesto sede{ id nombre} gestion}
            # pagos_inscripcion {}
        }}`;
      return this.$apollo
        .query({ query: sql })
        .then(({ data }) => {
          //window.console.log(this.programa.id, 'dfsfs');

          if (this.padre) this.padre.loadinddeta = false;
          return data.getInscripcion;
        })
        .catch((e) => {
          window.console.log('------------', e);
          if (this.padre) this.padre.loadinddeta = false;
          this.$root.$notify.show(`No de puede cargar el detalle`, { color: 'info' });
          return {};
        });
    },
    async solicitarCertificado() {
      if (!this.opcionSeleccionada) {
        return this.$emit('error', 'Debes seleccionar el tipo de solicitud');
      }

      this.cargando = true;

      try {
        const payload = {
          enrollment_id: this.inscripcion.id,
          option_id: this.programauniversidad.id,
          opcion: this.opcionSeleccionada,
          reason: this.motivo,
          manager_id: this.usuario.id,
        };

        // Suponiendo que tienes un servicio API:
        const response = await xaxios.post(`${API_URL}/certificados/request/granted`, payload)
        //const response = await xaxios.get(`${API_URL}/certificados/requests/inscripcion/${inscripcion_id}`);
        window.console.log(response)
        this.getSolicitudes(this.inscripcion.id);
        this.$root.$notify.show(`Solicitud enviada correctamente`, { color: 'success' });
        this.dialog1 = false;
        await this.$api.solicitudes.crear(payload);


        this.$emit('success', 'Solicitud enviada correctamente');
      } catch (err) {
        this.$emit('error', 'Error al realizar la solicitud');
      } finally {
        this.cargando = false;
      }
    },
    async verCertificado(item) {
      window.console.log('verCertificado', item);
      this.dialogCertificado = true;
      this.loadingCertificado = true;
      this.pdfUrl = null; // Limpia la URL del PDF antes de generar uno nuevo

      try {
        const response = await xaxios.get(`${API_URL}/certificados/request/${item.ID}/certificado`, {
          params: {
            isimprimir: false
          },
          responseType: 'blob'

        });


        const blob = response.data;
        this.pdfUrl = URL.createObjectURL(blob);
        //this.busqueda();
        this.$root.$notify.show(`Obtenido Corrrectamente`, { color: 'success' });

      } catch (err) {
        window.console.error("Error generando certificado:", err);
        let errorMessage = 'Hubo un error inesperado al obtener el certificado.';
        if (err.response) {
          // El servidor respondió con un status code fuera del rango 2xx
          // Aquí es donde comprobamos si la respuesta de error es un JSON.
          // xaxios intenta parsear automáticamente las respuestas JSON cuando responseType no es 'blob'
          // o cuando el Content-Type de la respuesta de error es 'application/json'.
          // Si el Content-Type es JSON, err.response.data ya será un objeto.
          // Si err.response.data sigue siendo un Blob (porque el backend devolvió un blob con status de error),
          // tendremos que leerlo explícitamente.

          if (err.response.data instanceof Blob) {
            // Si el Content-Type del error NO era application/json, xaxios aún lo dejó como Blob.
            // Necesitamos leerlo para ver si es un JSON adentro.
            const reader = new FileReader();
            reader.onload = async () => {
              try {
                const errorJson = JSON.parse(reader.result);
                errorMessage = `Error del servidor (${err.response.status}): ${errorJson.message || errorJson.error || JSON.stringify(errorJson)}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });

                //                this.showSnackbar(errorMessage, 'error');
              } catch (e) {
                // No es un JSON válido o hubo otro problema al leer el blob de error
                errorMessage = `Error del servidor (${err.response.status}): ${err.response.statusText || 'Respuesta de error no legible.'}`;
                this.$root.$notify.show(errorMessage, { color: 'error' });

                //                this.showSnackbar(errorMessage, 'error');
              }
            };
            reader.readAsText(err.response.data);
            // Retornamos aquí porque la notificación se mostrará asincrónicamente
            return;
          } else if (typeof err.response.data === 'object' && err.response.data !== null) {
            // Si err.response.data ya es un objeto (porque Content-Type era application/json)
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data.message || err.response.data.error || JSON.stringify(err.response.data)}`;
          } else {
            // Si no es un Blob ni un objeto, podría ser texto plano o vacío
            errorMessage = `Error del servidor (${err.response.status}): ${err.response.data || err.response.statusText || 'Respuesta de error desconocida.'}`;
          }

        } else if (err.request) {
          // La petición fue hecha pero no se recibió respuesta (ej: red, CORS)
          errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión de red o la configuración CORS.';
        } else {
          // Algo sucedió al configurar la petición
          errorMessage = `Error de la aplicación: ${err.message}`;
        }

        // Muestra el snackbar con el mensaje de error (si no fue manejado asincrónicamente por el FileReader)
        if (!(err.response && err.response.data instanceof Blob)) {
          this.showSnackbar(errorMessage, 'error');
        }
        window.console.error("Error generando certificado:", err.response.data.error);

        this.$root.$notify.show(errorMessage, { color: 'error' });
      }finally {
        this.loadingCertificado = false;
      }

    }
  }
};
</script>

<style scoped></style>